import tippy from "tippy.js/dist/tippy.all";
export default function loadTooltips() {

  const tooltips = document.querySelectorAll('[data-toggle="tooltip"]');

  if(tooltips.length > 0) {
    tippy(tooltips, {
      placement: 'top',
      arrow: true,
      arrowType: 'round',
      animation: 'shift-toward',
      theme: 'selectra',
      performance: true,
      interactive: true
      }
    );
  }
};
